import { FHConfirmDialog } from '../../../../../components/base';
import { ProgressBarThemes, Themes } from '../../../../../constants';
import { getHeaderDialogCopy } from '../utils';
import ClonePlanDialogContent from './ClonePlanDialogContent';
import DeletePlanDialogContent from './DeletePlanDialogContent';

import type { HeaderDialogsProps } from './types';

export default function HeaderDialogs({
  activeDialog,
  onClose,
  onConfirm,
  isSubmitting,
  isReportLoading,
  planLabel,
  activePlanLabel,
  clientLabel,
  isPlanActive,
}: HeaderDialogsProps) {
  if (!activeDialog) return null;

  switch (activeDialog.kind) {
    case 'clonePlan':
      return (
        <FHConfirmDialog
          open
          colorTheme={Themes.Primary}
          contentRenderer={() => (
            <ClonePlanDialogContent
              isPlanActive={isPlanActive}
              planLabel={planLabel}
              clientLabel={clientLabel}
            />
          )}
          submittext="CLONE PLAN"
          canceltext="CANCEL"
          submitBtnTestId="submitConfirmDialog"
          submitLoading={isSubmitting}
          disableSubmitButton={isSubmitting}
          onClose={onClose}
          onSubmit={onConfirm}
        />
      );
    case 'delete':
      return (
        <FHConfirmDialog
          open
          colorTheme={Themes.Primary}
          title="Delete treatment plan"
          contentRenderer={() => <DeletePlanDialogContent planLabel={planLabel} />}
          submittext="DELETE"
          canceltext="CANCEL"
          submitLoading={isSubmitting}
          disableSubmitButton={isSubmitting}
          onClose={onClose}
          onSubmit={onConfirm}
        />
      );
    case 'reportProgress':
      return (
        <FHConfirmDialog
          open
          colorTheme={Themes.Primary}
          content="Your treatment plan report is being processed. Please wait for the download to complete."
          hideCancelButton
          hideSubmitButton
          hideCloseIcon
          showProgressBar
          progressBarTheme={ProgressBarThemes.Secondary}
        />
      );
    default: {
      const copy = getHeaderDialogCopy(activeDialog, {
        planLabel,
        activePlanLabel,
        isReportLoading,
      });
      if (!copy) return null;
      const isBusy = isSubmitting || (activeDialog.kind === 'reportConfirm' && isReportLoading);
      return (
        <FHConfirmDialog
          open
          colorTheme={Themes.Primary}
          content={copy.content}
          submittext={copy.submitText}
          canceltext={copy.cancelText}
          hideCancelButton={copy.hideCancel}
          submitLoading={isBusy}
          disableSubmitButton={isBusy}
          submitBtnTestId={copy.submitTestId}
          cancelBtnTestId={copy.cancelTestId}
          onClose={onClose}
          onSubmit={onConfirm}
        />
      );
    }
  }
}
